import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Camera, Home, AlertCircle } from 'lucide-react';
import Button from '../../components/ui/Button';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-accent-primary to-accent-secondary rounded-2xl mb-4 shadow-accent-glow">
            <Camera size={32} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-text-primary">Vision 24</h1>
        </div>

        {/* 404 Card */}
        <div className="bg-surface-primary rounded-card shadow-card border border-surface-secondary p-8 md:p-12 text-center">
          <div className="mb-6">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-status-warning/20 to-status-danger/20 rounded-full mb-4">
              <AlertCircle size={48} className="text-status-warning" />
            </div>
            
            <h1 className="text-6xl md:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-accent-primary to-accent-secondary mb-4">
              404
            </h1>
            
            <h2 className="text-2xl md:text-3xl font-semibold text-text-primary mb-3">
              Page Not Found
            </h2>
            
            <p className="text-text-secondary text-base md:text-lg max-w-md mx-auto mb-8">
              The page you're looking for doesn't exist or has been moved. 
              Let's get you back to safety.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Button
              variant="primary"
              size="lg"
              onClick={handleGoHome}
              leftIcon={<Home size={20} />}
            >
              Back to Dashboard
            </Button>
          </div>

          {/* Additional help text */}
          <div className="mt-8 pt-6 border-t border-surface-secondary">
            <p className="text-text-muted text-sm">
              If you believe this is an error, please contact your system administrator.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
